module.exports = "pegasus_template/assets/tech/webinar/100.png";